import React from 'react';

import Reveal from '../ui/Reveal';

/** A strip of headline figures, one hairline-divided cell per figure. */
export default function Stats({ items }) {
    return (
        <ul className="stats" style={{ '--cols': items.length }}>
            {items.map((item, i) => (
                <Reveal as="li" className="stats__cell" key={item.label} delay={i * 0.08} y={22}>
                    <span className="stats__value">{item.value}</span>
                    <span className="stats__label">{item.label}</span>
                </Reveal>
            ))}
        </ul>
    );
}
